import React from "react";
import axios from "axios";

export const paymentPopupApi = async (application_id, token, provider, callback_url) => {

  try {
    let url = `https://visapro.herokuapp.com/api/v1/applications/${application_id}/pay`;
    const response = await axios.get(url, {
        headers: {
          'Authorization': `Bearer ${token}` 
        },
        params: {
            provider,
            callback_url
        }
    });
    const payment = {
      data: response.data,
    };
    return payment;
  } catch (error) {
    const payment = {
      error: error,
    };
    return payment;
  }
};
